import { GoTop } from "@/js/components/GoTop";
import { Takeover } from "@/js/components/Takeover";
import { BackgroundVideo } from "@/js/components/BackgroundVideo";
import { AgreeCheckbox } from "@/js/components/AgreeCheckbox";
import { NestedLink } from "@/js/components/NestedLink";
import { HeaderSearch } from "@/js/components/HeaderSearch";
import { HeaderDrawer } from "@/js/components/HeaderDrawer";
import { SubmitFormLink } from "@/js/components/SubmitFormLink";
import { BlogParts } from "@/js/components/Blogparts";
import { SearchableSelect } from "@/js/components/SearchableSelect";
import { JobEventDispatcher } from "@/js/components/JobEventDispatcher";
import { ScheduleCalendar } from "@/js/components/ScheduleCalendar";
import { FixedBannerMobile } from "./components/FixedBannerMobile";
import { LazyLoadingImage } from "@/js/components/LazyLoadingImage";

const searchParams = new URLSearchParams(window.location.search);

if (window.location.href.indexOf("mock") !== -1) {
    if (searchParams.has("takeover")) {
        document.body.classList.add("has-takeover");
    } else if (searchParams.has("bg-video")) {
        document.body.classList.add("has-bg-video");
    }
}

GoTop.attach(".js-footer__go-top");
AgreeCheckbox.attach();
NestedLink.attach();
Takeover.attach();
BackgroundVideo.attach();
SubmitFormLink.attach(".js-submit-form-link");
BlogParts.attach();
HeaderSearch.attach();
HeaderDrawer.attach();
SearchableSelect.attach();
JobEventDispatcher.attach();
ScheduleCalendar.attach();
FixedBannerMobile.attach();
LazyLoadingImage.attach();
